import types from 'actions/types'

export const trackRoute = (key, route) => ({ type: types.TRACK_ROUTE, key, route })

export const unTrackRoutes = () => ({ type: types.UN_TRACK_ROUTES })
